
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";
import { useSafeNavigation } from "@/components/SafeNavigation";

const Plans = () => {
  const navigate = useNavigate();
  const { safeNavigate } = useSafeNavigation("/settings");

  // Updated to navigate to settings
  const handleGoBack = () => {
    safeNavigate("/settings");
  };

  return (
    <div className="container max-w-6xl py-8 space-y-6">
      {/* Back button */}
      <div className="flex justify-start mb-4">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleGoBack}
          className="flex items-center gap-1"
        >
          <ArrowLeft className="h-4 w-4" /> 
          Voltar
        </Button>
      </div>
      
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold mb-2">Acesso Completo</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Todos os recursos estão disponíveis para todos os usuários. 
          O sistema de assinaturas foi removido.
        </p>
      </div>

      <Card className="max-w-lg mx-auto">
        <CardHeader>
          <CardTitle>Funcionalidade de Assinatura Removida</CardTitle>
          <CardDescription>
            O sistema de pagamentos e assinaturas foi removido desta aplicação.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="mb-4">
            Todos os usuários agora têm acesso completo a todas as funcionalidades sem necessidade de assinatura.
          </p>
          <Button 
            onClick={() => navigate("/settings")} 
            variant="outline"
            className="mt-4"
          >
            Voltar para Configurações
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Plans;
